module.exports = __webpack_public_path__ + "img/destination-cancun.66562aef.jpg";